mainApp.directive('docExpandedTableRow', ['DiscoveryQueryService', '$state', '$sce', function(DiscoveryQueryService, $state, $sce) {
    return {
        templateUrl: '/public/components/discovery/doc-expanded-table-row.directive.html',
        restrict: 'A',
        link: function(ctrl, el, attrs) {

            ctrl.fieldsSpec = ctrl.$eval(attrs.fieldsSpec);

            ctrl.exceptionConfigVisible = false;
            ctrl.ipsWhiteListVisible = false;

            ctrl.selectedTab = 'table';

            ctrl.eventSubType = ctrl.$eval(attrs.doc)['event_sub_type'];
            ctrl.action = ctrl.$eval(attrs.doc)['action'];

            ctrl.hasRule = ctrl.eventSubType === 'WAN Rule' ||
                ctrl.eventSubType === 'Internet Rule' ||
                ctrl.eventSubType === 'URL Filtering' ||
                ctrl.eventSubType === 'Internet Firewall' ||
                ctrl.eventSubType === 'WAN Firewall' ||
                ctrl.eventSubType === 'Last-Mile Quality';

            ctrl.addColumn = function(field) {
                ctrl.$eval(attrs.onColumnAdd, {field: field});
            }

            ctrl.addValueFilter = function(field, value) {
                ctrl.$eval(attrs.onAddFilter, {field: field, value: value, operator: 'is'});
            }

            ctrl.addValueExclusionFilter = function(field, value) {
                ctrl.$eval(attrs.onAddFilter, {field: field, value: value, operator: 'is_not'});
            }

            ctrl.formatValue = function(field, value) {
                return ctrl.$eval(attrs.valueFormatter, {field: field, value: value});
            }

            ctrl.goToEditPage = function() {
                $state.go(ctrl.ruleData.gotoState, ctrl.ruleData.state);
            }

            ctrl.fetchPolicyRuleData = function(entityType, gotoState, gotoStateParam, gotoStateVal) {
                if (ctrl.ruleData)
                    return;

                store.fetch({
                    method: 'POST',
                    path: "/policy?type=" + entityType + "&accountId=" + $state.params.accountId + "&ruleId=" + ctrl.doc['rule_id'] + "&effectiveTime=" + ctrl.doc['time'],
                    success: function(data) {
                        if (data.total === 0) {
                            ctrl.ruleData = {};
                        } else {
                            ctrl.ruleData = {item: data.items[0], gotoState: gotoState, state: {[gotoStateParam]: gotoStateVal}};
                        }
                    }
                });
            }

            ctrl.fetchURLFilteringData = function() {
                if (ctrl.ruleData)
                    return;

                let queryConfig = {
                    "dateField": "",
                    "fromDate": 0,
                    "toDate": ctrl.doc['time'],
                    "from":0,"limit":20,
                    "searchField":"name",
                    exactTerm: true,
                    "orders":[
                        {"path":"name","dir":"ASC"}
                    ],
                    "type":"URLFilteringRule"
                };

                let url;
                let state;

                if (ctrl.doc['rule_name']) {
                    url = "/urlFilteringCustomRules";
                    queryConfig.search = ctrl.doc['rule_name'] ? ctrl.doc['rule_name'] : "##?C_A_T_O?##";
                    queryConfig.type = "URLFilterCustomCategoryRule";
                    state = {customCategoryName: ctrl.doc['rule_name']}
                } else if (ctrl.doc['categories'] && ctrl.doc['categories'].length > 0) {
                    url = "/urlFiltering";
                    queryConfig.search = ctrl.doc['categories'][0];
                    queryConfig.type = "URLFilteringRule";
                    state = {categoryName: ctrl.doc['categories'][0]}
                }

                store.fetch({
                    method: 'POST',
                    path: url + "?accountId=" + $state.params.accountId,
                    data: queryConfig,
                    dataObj: 'dataConfig',
                    success: function(data) {
                        if (data.total === 0) {
                            ctrl.ruleData = {};
                        } else {
                            ctrl.ruleData = {item: data.items[0], gotoState: 'app.urlFiltering', state: state};
                        }
                    }
                });
            }

            let trafficTypesMap = {
                OUTBOUND: 'Outbound',
                INBOUND: 'Inbound',
                WANBOUND: 'WAN'
            }

            function isSignatureIpBased() {
                return (DiscoveryQueryService.feedTypeIpSignatures &&
                    DiscoveryQueryService.feedTypeIpSignatures[ctrl.doc.signature_id]);
            }

            ctrl.showIpsWhitelistRuleDialog = function() {
                var initialCategories = [];
                var initialFrom = [{'id': -1, 'name': 'Any', 'display_name': 'Any'}];
                var initialTo = [];

                if (ctrl.doc.traffic_direction === 'OUTBOUND') {
                    if (ctrl.doc.hasOwnProperty('domain_name') &&
                    ctrl.doc.signature_id !== "GEO_RESTRICTION" &&
                    !isSignatureIpBased()) {

                        const pattern = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])(\/([0-9]|[1-2][0-9]|3[0-2]))?$/gm;
                        let initialType = "TLD";

                        if (pattern.test(ctrl.doc.domain_name)) {
                            // Some event actually hold ip in domain name,
                            // for that we change the type but still use the same value
                            initialType = "IpRange";
                        }

                        initialCategories = [{
                                        id: ctrl.doc.domain_name,
                                        display_name: ctrl.doc.domain_name ? ctrl.doc.domain_name : 'Any',
                                        type: initialType}]
                    } else {
                        // If no domain name in event, use ip
                        initialCategories = [{
                            id: ctrl.doc.dest_ip,
                            name: ctrl.doc.dest_ip ? ctrl.doc.dest_ip : 'Any',
                            type: "IpRange"}]
                    }
                } else {
                    initialTo = [{
                        id: 0,
                        pid: 0,
                        name: ctrl.doc.dest_ip ? ctrl.doc.dest_ip : 'Any',
                        type: "IP"}]
                }

                if (ctrl.doc.traffic_direction === 'INBOUND') {
                    initialCategories = [{
                        id: ctrl.doc.src_ip,
                        name: ctrl.doc.src_ip ? ctrl.doc.src_ip : 'Any',
                        type: "IpRange"}]
                } else {
                    initialFrom = [{entityType: "IP",
                        id: 0,
                        name: ctrl.doc.src_ip ? ctrl.doc.src_ip : 'Any',
                        pid: 0,
                        type: "IP"}]
                }

                var portProtocol = ctrl.doc.ip_protocol + "/" + ctrl.doc.dest_port;

                if (!ctrl.doc.dest_port || ctrl.doc.dest_port === 0) {
                    portProtocol = ctrl.doc.ip_protocol;
                }

                ctrl.ipsWhiteListConfig = {
                    name: '',
                    ipsRuleType: trafficTypesMap[ctrl.doc.traffic_direction],
                    signatureId: ctrl.doc.signature_id,
                    from: initialFrom,
                    categories: initialCategories,
                    to: initialTo,
                    portsProtocolsList: [{"port":ctrl.doc.dest_port,"protocol":ctrl.doc.ip_protocol,"id":portProtocol,"display_name":portProtocol,"type":"PORT_PROTOCOL"}],
                    description: '',
                    enabled: true,
                    ruleEnabled: true,
                    signatureExists: true,
                    id: Math.floor(Math.random() * 100000000000000 + 1) * -1
                };

                ctrl.ipsWhiteListVisible = true;
            }

            ctrl.saveIpsWhitelistRule = function () {
                ctrl.ipsWhiteListConfig.description = ctrl.ipsWhiteListConfig.name;
                let params = {
                    accountId: $state.params.accountId,
                    type: 'IPSWHITELISTRULE',
                    save: true
                };

                store.save({
                    path: '/addEntityOfType',
                    queryParams: params,
                    data: ctrl.ipsWhiteListConfig,
                    dataObj: 'json',
                    success: function(data) {
                        ctrl.$root.handleServerResponse(data, "", "IPS whitelist rule was added");
                        if (data.status !== "ERROR") {
                            ctrl.ipsWhiteListConfig = null;
                            ctrl.closeIpsWhitelistRuleDialog();
                        }
                    }
                });
            }

            ctrl.closeIpsWhitelistRuleDialog = function() {
                ctrl.ipsWhiteListVisible = false;
            }

            ctrl.showConfigExceptionDialog = function() {
                store.fetch({
                    method: 'POST',
                    path: "/avException?accountId=" + $state.params.accountId + "&id=" + ctrl.doc.file_hash,
                    success: function(data) {
                        if (data.total === 0) {
                            ctrl.exceptionConfigData = {
                                name: ctrl.doc.file_hash,
                                fileName: ctrl.doc.url !== 'N/A' ? ctrl.doc.url.replace(/^.*[\\\/]/, '') : 'N/A',
                                hash: ctrl.doc.file_hash
                            };
                        } else {
                            ctrl.exceptionConfigData = data.items[0];

                            ctrl.exceptionConfigActions = {
                                "ALLOW":{"name":"Allow","icon":"allow",class:"action-allow"},
                                "BLOCK":{"name":"Block","icon":"block",class:"action-block"},
                                "MONITOR":{"name":"Monitor","icon":"monitor",class:"action-monitor"},
                                "PROMPT":{"name":"Prompt","icon":"prompt",class:"action-alert"}
                            };
                        }

                        ctrl.exceptionConfigData.avExceptionDuration = "7";
                        ctrl.exceptionConfigVisible = true;
                    }
                });
            }

            ctrl.closeConfigExceptionDialog = function() {
                ctrl.exceptionConfigVisible = false;
            }

            ctrl.saveConfigException = function () {
                ctrl.exceptionConfigData.expirationDate = new Date();
                if (ctrl.exceptionConfigData.avExceptionDuration === "0")
                    ctrl.exceptionConfigData.expirationDate = new Date(0);
                else
                    ctrl.exceptionConfigData.expirationDate.setDate(ctrl.exceptionConfigData.expirationDate.getDate() + parseInt(ctrl.exceptionConfigData.avExceptionDuration));

                ctrl.exceptionConfigData.expirationDate = ctrl.exceptionConfigData.expirationDate.getTime();
                ctrl.exceptionConfigData.newSaveMethod = true;


                let path, params;
                if (ctrl.exceptionConfigData.id) {
                    path = "/edit";
                    params = {
                        avexceptionId: ctrl.exceptionConfigData.id,
                        save: true,
                        fields: ['expirationDate', 'comment']
                    };
                } else {
                    path = "/add";
                    params = {
                        accountId: $state.params.accountId,
                        type: 'avRuleException',
                        save: true
                    };
                }

                store.save({
                    path: path,
                    queryParams: params,
                    data: ctrl.exceptionConfigData,
                    dataObj: 'json',
                    success: function(data) {
                        ctrl.$root.handleServerResponse(data, "", "Anti Malware exception was added");
                        if (data.status !== "ERROR") {
                            ctrl.exceptionConfigData = null;
                            ctrl.closeConfigExceptionDialog();
                        }
                    }
                });
            };
        },
        controller: function($scope, IconsService, FieldsService) {
            const FieldTypes = FieldsService.getFieldTypes();

            $scope.icons = IconsService.getIcons('policy');

            $scope.rulesFields = {
                portsProtocolsList: {
                    name: 'portsProtocolsList',
                    id: 'portsProtocolsList',
                    types: [
                        {
                            name: 'Protocol/Port',
                            field: FieldTypes.portsProtocols,
                        }]
                },
                Inbound: {
                    categories: {
                        name: 'Category',
                        id: 'categories',
                        types: [
                            {
                                name: 'Any',
                                field: FieldTypes.all,
                            },
                            {
                                name: 'IP Range',
                                field: FieldTypes.adhocIpRange
                            },
                            {
                                name: 'Remote ASN',
                                field: FieldTypes.asn
                            },
                            {
                                name: 'Countries',
                                field: FieldTypes.countries
                            }
                        ]
                    },
                    to: {
                        name: 'To',
                        id: 'to',
                        types: [
                            {
                                name: 'Any',
                                field: FieldTypes.all,
                            },
                            {
                                name: 'IP',
                                field: FieldTypes.ips,
                            },
                            {
                                name: 'Directory Users',
                                field: FieldTypes.dsUser
                            },
                            {
                                name: 'VPN User',
                                field: FieldTypes.accesslogins
                            },
                            {
                                name: 'Host',
                                field: FieldTypes.subnets
                            },
                            {
                                name: 'Groups',
                                field: FieldTypes.groups
                            },
                            {
                                name: 'Sites',
                                field: FieldTypes.sites,
                            },
                            {
                                name: 'Floating ranges',
                                field: FieldTypes.floatingIps
                            },
                            {
                                name: 'Networks',
                                field: FieldTypes.ipRanges,
                            }
                        ]
                    }
                },
                Outbound: {
                    from: {
                        name: 'From',
                        id: 'from',
                        types: [
                            {
                                name: 'Any',
                                field: FieldTypes.all,
                            },
                            {
                                name: 'IP',
                                field: FieldTypes.ips,
                            },
                            {
                                name: 'Directory Users',
                                field: FieldTypes.dsUser
                            },
                            {
                                name: 'VPN User',
                                field: FieldTypes.accesslogins
                            },
                            {
                                name: 'Groups',
                                field: FieldTypes.groups
                            },
                            {
                                name: 'Sites',
                                field: FieldTypes.sites,
                            },
                            {
                                name: 'Floating ranges',
                                field: FieldTypes.floatingIps
                            },
                            {
                                name: 'Networks',
                                field: FieldTypes.ipRanges,
                            }]
                    },
                    categories: {
                        name: 'Category',
                        id: 'categories',
                        types: [
                            {
                                name: 'Any',
                                field: FieldTypes.all,
                            },
                            {
                                name: 'IP Range',
                                field: FieldTypes.adhocIpRange
                            },
                            {
                                name: 'Remote ASN',
                                field: FieldTypes.asn
                            },
                            {
                                name: 'Countries',
                                field: FieldTypes.countries
                            },
                            {
                                name: 'FQDN',
                                field: FieldTypes.FQDN
                            },
                            {
                                name: 'Domain',
                                field: FieldTypes.TLD
                            }
                        ]
                    }
                },
                WAN: {
                    from: {
                        name: 'From',
                        id: 'from',
                        types: [
                            {
                                name: 'Any',
                                field: FieldTypes.all,
                            },
                            {
                                name: 'IP',
                                field: FieldTypes.ips,
                            },
                            {
                                name: 'Directory Users',
                                field: FieldTypes.dsUser
                            },
                            {
                                name: 'VPN User',
                                field: FieldTypes.accesslogins
                            },
                            {
                                name: 'Groups',
                                field: FieldTypes.groups
                            },
                            {
                                name: 'Sites',
                                field: FieldTypes.sites,
                            },
                            {
                                name: 'Floating ranges',
                                field: FieldTypes.floatingIps
                            },
                            {
                                name: 'Host',
                                field: FieldTypes.subnets
                            },
                            {
                                name: 'Networks',
                                field: FieldTypes.ipRanges,
                            }]
                    },
                    to: {
                        name: 'To',
                        id: 'to',
                        types: [
                            {
                                name: 'Any',
                                field: FieldTypes.all,
                            },
                            {
                                name: 'IP',
                                field: FieldTypes.ips,
                            },
                            {
                                name: 'Directory Users',
                                field: FieldTypes.dsUser
                            },
                            {
                                name: 'VPN User',
                                field: FieldTypes.accesslogins
                            },
                            {
                                name: 'Groups',
                                field: FieldTypes.groups
                            },
                            {
                                name: 'Sites',
                                field: FieldTypes.sites,
                            },
                            {
                                name: 'Floating ranges',
                                field: FieldTypes.floatingIps
                            },
                            {
                                name: 'Host',
                                field: FieldTypes.subnets
                            },
                            {
                                name: 'Networks',
                                field: FieldTypes.ipRanges,
                            }]
                    }
                }
            };
        }
    }}]);